/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeammateAnalyticsCard_profileTimeZone = {
    readonly timeZone: string;
    readonly " $fragmentRefs": FragmentRefs<"CalendarStatus_profileTimeZone" | "CalendarTimeZone_profileTimeZone">;
    readonly " $refType": "TeammateAnalyticsCard_profileTimeZone";
};
export type TeammateAnalyticsCard_profileTimeZone$data = TeammateAnalyticsCard_profileTimeZone;
export type TeammateAnalyticsCard_profileTimeZone$key = {
    readonly " $data"?: TeammateAnalyticsCard_profileTimeZone$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_profileTimeZone">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeammateAnalyticsCard_profileTimeZone",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarStatus_profileTimeZone"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarTimeZone_profileTimeZone"
        }
    ],
    "type": "ProfileTimeZone",
    "abstractKey": null
} as any;
(node as any).hash = '7979ec4bbb7cb60600d9b843d9e89f1e';
export default node;
